import React from 'react';
import { StyledBoxIndustries } from './StyledBoxIndustries';

const BoxIndustries = ({ title, text, black }) => {
  return (
    <React.Fragment>
      {
       
          <StyledBoxIndustries className="box--industries">
            <div className="box--industries-wrap">
              <p className="preset-9 box--title" style={{color: black}}>{title}</p>
              <p className="preset-10 box--text" >{text}</p>
              <div className="box--anchor"></div>
              <div className="box--anchor-line"></div>
            </div>
            
          </StyledBoxIndustries>
          
      }
    </React.Fragment>
  );
};

BoxIndustries.propTypes = {};

BoxIndustries.defaultProps = {
  black: "#003D2B"
};

export default BoxIndustries;
